import { createGlobalStyle } from "styled-components";

const GlobalStarterStyles = createGlobalStyle`
  * {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }
  html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
  }
  article,
  aside,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  nav,
  section {
    display: block;
  }
  body {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
  }
  [tabindex='-1']:focus {
    outline: 0 !important;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  abbr[data-original-title],
  abbr[title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
  }
  address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
  }
  dl,
  ol,
  ul {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  ol ol,
  ol ul,
  ul ol,
  ul ul {
    margin-bottom: 0;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
  }
  blockquote {
    margin: 0 0 1rem;
  }
  dfn {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bolder;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }
  a:hover {
    color: #0056b3;
    text-decoration: none;
  }
  a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
  }
  a:not([href]):not([tabindex]):focus,
  a:not([href]):not([tabindex]):hover {
    color: inherit;
    text-decoration: none;
  }
  a:not([href]):not([tabindex]):focus {
    outline: 0;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    font-size: 1em;
  }
  pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    -ms-overflow-style: scrollbar;
  }
  figure {
    margin: 0 0 1rem;
  }
  img {
    vertical-align: middle;
    border-style: none;
  }
  svg {
    overflow: hidden;
    vertical-align: middle;
  }
  table {
    border-collapse: collapse;
  }
  caption {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    color: #6c757d;
    text-align: left;
    caption-side: bottom;
  }
  th {
    text-align: inherit;
  }
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }
  button {
    border-radius: 0;
  }
  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  [type='reset'],
  [type='submit'],
  button,
  html [type='button'] {
    -webkit-appearance: button;
  }
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner,
  button::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }
  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  input[type='date'],
  input[type='datetime-local'],
  input[type='month'],
  input[type='time'] {
    -webkit-appearance: listbox;
  }
  textarea {
    overflow: auto;
    resize: vertical;
  }
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }
  legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    outline-offset: -2px;
    -webkit-appearance: none;
  }
  [type='search']::-webkit-search-cancel-button,
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }
  output {
    display: inline-block;
  }
  summary {
    display: list-item;
    cursor: pointer;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none !important;
  }

  .w-max {
    width: 1152px;
  }

  .w-max-strict {
    width: 1152px;
    min-width: 1152px;
    max-width: 1152px;
  }

  .card-response {
    width: 270px;
    height: 380px;
    min-width: 270px;
    min-height: 380px;
    max-width: 270px;
    max-height: 380px;
  }

  .card-grid-response {
    display: grid;
    grid-template-columns: repeat(4, 270px);
    gap: 24px;
  }
  /* Глобальные стили для кнопок в компетишене, которые просила Алёна) */
  .comps-btn_white {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    border: 1px solid #B6B6B5;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    transition: border 0.5s;
    white-space: pre;
  }

  .comps-btn_black {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border: 1px solid transparent;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    letter-spacing: -0.02em;
    background-color: #151514;
    transition: background-color 0.5s;
    white-space: pre;
  }

  .comps-btn_white > * {
    color: #151514;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
  }

  .comps-btn_black > * {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
  }

  .comps-btn_black:hover,
  .comps-btn_black:focus,
  .comps-btn_black:active {
    background-color: #1F1F1F;
    transition: background-color 0.5s;
  }

  .comps-btn_white:hover,
  .comps-btn_white:focus,
  .comps-btn_white:active {
    border: 1px solid #8E9193;
    transition: border 0.5s;
  }

  @media (max-width: 1280px) {
    .w-max {
      width: 940px;
    }

    .w-max-strict {
      width: 940px;
      min-width: 940px;
      max-width: 940px;
    }

    .card-response {
      width: 221.25px;
      height: 311.38px;
      min-width: 221.25px;
      min-height: 311.38px;
      max-width: 221.25px;
      max-height: 311.38px;
    }

    .card-grid-response {
      display: grid;
      grid-template-columns: repeat(4, 221.25px);
      gap: 19.6px;
    }
  }

  ::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
    border: 1px solid rgba(254, 254, 254, 0.13);
  }

  .onlines-font {
    font-family: 'Space Grotesk', sans-serif !important;
  }

  .onlines-desc {
    font-family: 'Montserrat' !important;
  }
`;

export default GlobalStarterStyles;
import { createGlobalStyle } from "styled-components";

const GlobalStarterStyles = createGlobalStyle`
  * {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }
  html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
  }
  article,
  aside,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  nav,
  section {
    display: block;
  }
  body {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
  }
  [tabindex='-1']:focus {
    outline: 0 !important;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  abbr[data-original-title],
  abbr[title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
  }
  address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
  }
  dl,
  ol,
  ul {
    margin-top: 0;
    margin-bottom: 1rem;
  }
  ol ol,
  ol ul,
  ul ol,
  ul ul {
    margin-bottom: 0;
  }
  dt {
    font-weight: 700;
  }
  dd {
    margin-bottom: 0.5rem;
    margin-left: 0;
  }
  blockquote {
    margin: 0 0 1rem;
  }
  dfn {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bolder;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }
  a:hover {
    color: #0056b3;
    text-decoration: none;
  }
  a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
  }
  a:not([href]):not([tabindex]):focus,
  a:not([href]):not([tabindex]):hover {
    color: inherit;
    text-decoration: none;
  }
  a:not([href]):not([tabindex]):focus {
    outline: 0;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
    font-size: 1em;
  }
  pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    -ms-overflow-style: scrollbar;
  }
  figure {
    margin: 0 0 1rem;
  }
  img {
    vertical-align: middle;
    border-style: none;
  }
  svg {
    overflow: hidden;
    vertical-align: middle;
  }
  table {
    border-collapse: collapse;
  }
  caption {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    color: #6c757d;
    text-align: left;
    caption-side: bottom;
  }
  th {
    text-align: inherit;
  }
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }
  button {
    border-radius: 0;
  }
  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  [type='reset'],
  [type='submit'],
  button,
  html [type='button'] {
    -webkit-appearance: button;
  }
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner,
  button::-moz-focus-inner {
    padding: 0;
    border-style: none;
  }
  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  input[type='date'],
  input[type='datetime-local'],
  input[type='month'],
  input[type='time'] {
    -webkit-appearance: listbox;
  }
  textarea {
    overflow: auto;
    resize: vertical;
  }
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
  }
  legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    outline-offset: -2px;
    -webkit-appearance: none;
  }
  [type='search']::-webkit-search-cancel-button,
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
  }
  output {
    display: inline-block;
  }
  summary {
    display: list-item;
    cursor: pointer;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none !important;
  }

  .w-max {
    width: 1152px;
  }

  .w-max-strict {
    width: 1152px;
    min-width: 1152px;
    max-width: 1152px;
  }

  .card-response {
    width: 270px;
    height: 380px;
    min-width: 270px;
    min-height: 380px;
    max-width: 270px;
    max-height: 380px;
  }

  .card-grid-response {
    display: grid;
    grid-template-columns: repeat(4, 270px);
    gap: 24px;
  }
  /* Глобальные стили для кнопок в компетишене, которые просила Алёна) */
  .comps-btn_white {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    border: 1px solid #B6B6B5;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    transition: border 0.5s;
    white-space: pre;
  }

  .comps-btn_black {
    font-family: "Inter";
    padding: 12px 32px 12px 24px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border: 1px solid transparent;
    border-radius: 3px;
    height: 48px;
    display: flex;
    place-items: center;
    justify-content: center;
    cursor: pointer;
    letter-spacing: -0.02em;
    background-color: #151514;
    transition: background-color 0.5s;
    white-space: pre;
  }

  .comps-btn_white > * {
    color: #151514;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
  }

  .comps-btn_black > * {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
  }

  .comps-btn_black:hover,
  .comps-btn_black:focus,
  .comps-btn_black:active {
    background-color: #1F1F1F;
    transition: background-color 0.5s;
  }

  .comps-btn_white:hover,
  .comps-btn_white:focus,
  .comps-btn_white:active {
    border: 1px solid #8E9193;
    transition: border 0.5s;
  }

  @media (max-width: 1280px) {
    .w-max {
      width: 940px;
    }

    .w-max-strict {
      width: 940px;
      min-width: 940px;
      max-width: 940px;
    }

    .card-response {
      width: 221.25px;
      height: 311.38px;
      min-width: 221.25px;
      min-height: 311.38px;
      max-width: 221.25px;
      max-height: 311.38px;
    }

    .card-grid-response {
      display: grid;
      grid-template-columns: repeat(4, 221.25px);
      gap: 19.6px;
    }
  }

  ::-webkit-scrollbar {
    width: 10px; /* ширина scrollbar */
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent; /* цвет дорожки */
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: rgba(0, 0, 0, 0.596);
    border: 1px solid rgba(254, 254, 254, 0.13);
  }

  .onlines-font {
    font-family: 'Space Grotesk', sans-serif !important;
  }

  .onlines-desc {
    font-family: 'Montserrat' !important;
  }
`;

export default GlobalStarterStyles;
